<template>
    <div id="heat-head" v-if="isHeatSelected">
        <div>
            <div class="event-name">{{ getGroupTitle }}</div>
            <div class="class-name">{{SelectedHeat.className}}</div>

        </div>
        <div class="icon" :class="{
            'none': SelectedHeat.state == 0,
            'start-list': SelectedHeat.state == 1,
            'in-progress': SelectedHeat.state == 2,
            'finished': SelectedHeat.state == 3,
        }"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: "HeatHead",
    computed:{
        ...mapGetters(['SelectedHeat']),
        isHeatSelected() {
            return this.SelectedHeat != '' && this.SelectedHeat != null;
        },        
        getGroupTitle() {
			if(this.SelectedHeat.squadGroupName){
                return this.SelectedHeat.eventName + ' ' + this.SelectedHeat.squadGroupName;
            }
            return this.SelectedHeat.eventName;
        }
    },
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    #heat-head {
        @extend %f-row;
        align-items: center;
        margin: 0 auto;

        > div {
            @extend %f-row;
            @extend %f-wrap;

            align-items: center;

            .event-name {
                font-size: 14px;
                font-weight: bold;       
            }

            .class-name {
                font-size:10px;
                font-size: 14px;
                font-weight: bold;  
            }

            >div {
                padding-left:10px;
            }
        }
        

        .icon {
            font: normal normal normal 24px/1 "Material Design Icons";
            padding: 10px;
        }
        .none::after {
            content: "\F0F08";
        }
        .start-list::after {
            content: "\F027B";
            color: $prim_aleart_light_color;
        }
        .in-progress::after {
            content: "\F040B";
            color: $prim_warning_color;
        }
        .finished::after {
            content: "\F023C";
        }
    }

</style>